import { render, staticRenderFns } from "./ReservationSummary.vue?vue&type=template&id=2ecd489b"
import script from "./ReservationSummary.vue?vue&type=script&lang=js"
export * from "./ReservationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports